import * as Sentry from '@sentry/react';
import type { ErrorContext } from '../types';

let initialized = false;

export function initSentry(dsn: string, appName: string, environment: string) {
  if (initialized || !dsn) return;

  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    beforeSend(event) {
      if (event.tags) {
        event.tags.app_name = appName;
      } else {
        event.tags = { app_name: appName };
      }
      return event;
    },
  });

  initialized = true;
}

export function captureError(error: Error, context?: ErrorContext) {
  if (!initialized) return;

  const contextTags = context?.tags || {};
  const contextExtra = context?.extra || {};
  const contextUser = context?.userId ? { id: context.userId } : undefined;

  const scopeData: any = {
    tags: {
      ...contextTags,
      context: context?.context,
    },
    extra: contextExtra,
  };

  if (contextUser) {
    scopeData.user = contextUser;
  }

  Sentry.captureException(error, scopeData);
}

export function captureMessage(message: string, level: 'info' | 'warning' | 'error' = 'info') {
  if (!initialized) return;
  Sentry.captureMessage(message, level);
}

export function setUser(userId: string, email?: string) {
  if (!initialized) return;
  Sentry.setUser(email !== undefined && email !== '' ? { id: userId, email } : { id: userId });
}
